import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/main.scss';
import App from './App';
import {BrowserRouter} from 'react-router-dom';

const host = window.location.host;
const http = window.location.protocol;
let a = host;
if(host.includes('localhost'))  a = '127.0.0.1:8000';
if(host.includes('devel'))  a = 'pvkurzy.tw-planner.com';
if(host.includes('platformavize0'))  a = window.location.host+'/index.php';
export const APIURL = http+"//"+a+"/api";

const root = ReactDOM.createRoot(document.body);
root.render(
  <React.StrictMode>
    <BrowserRouter basename='/'>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
